import { render, staticRenderFns } from "./naciones-unidas.vue?vue&type=template&id=08f7c51c&scoped=true"
import script from "./naciones-unidas.vue?vue&type=script&lang=js"
export * from "./naciones-unidas.vue?vue&type=script&lang=js"
import style0 from "./naciones-unidas.vue?vue&type=style&index=0&id=08f7c51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7c51c",
  null
  
)

export default component.exports